import { connect } from "react-redux";
import { PageSummary } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { PageHelpStateProps, PageHelpDispatchProps, PageHelp } from "senac-components/dist/pages/Mobile/PageHelp";


const mapState = (state: RootState, props: any) => 
{
  return {};
};

const mapDispatch = (dispatch: AppDispatch, props:any) => 
{
  const result: PageHelpDispatchProps  = 
  {
    onClickBack: ()=> dispatch(commonSlice.actions.backPage()),
  };
  return result;
};


const WPageHelp = connect(mapState, mapDispatch)(PageHelp);

export { WPageHelp };
